module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12,
      "xs": {
        span: 18
      }
    }
  }, [_c('div', {
    staticClass: "systemName"
  }, [_c('img', {
    staticClass: "systemName-logo",
    attrs: {
      "src": require("../../../static/img/logo_ycx.png"),
      "height": "32px",
      "alt": "系统LOGO"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5b98971a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Header.vue
// module id = YZfm
// module chunks = 273